import { Typography } from "@mui/material";
import {
    CONTENT_ALIGNMENT_DEFAULT,
    HEADING_FONT_DEFAULT,
    HEADING_SIZE_DEFAULT,
    HEADING_WEIGHT_DEFAULT,
} from "modules/pvs_activities/constants";
import React, { useMemo } from "react";

const defaultProps = {
    size: HEADING_SIZE_DEFAULT,
    align: CONTENT_ALIGNMENT_DEFAULT,
    font: HEADING_FONT_DEFAULT,
    weight: HEADING_WEIGHT_DEFAULT,
    italic: false,
    underline: false,
    label: "",
    className: "",
    sx: {},
};

const Heading = (rawProps) => {
    const props = { ...defaultProps, ...rawProps };

    const size = useMemo(() => {
        const tmp = props.size ?? HEADING_SIZE_DEFAULT;
        if (tmp === "normal") return "body1";
        return tmp;
    }, [props.size]);

    const mySx = useMemo(() => {
        const fontFamily = props.font ?? HEADING_FONT_DEFAULT;
        const fontWeight = props.weight ?? HEADING_WEIGHT_DEFAULT;
        const letterSpacing = String(fontFamily).trim().toLowerCase() === "sohneschmal-kraftig" ? "2px" : "normal";
        return {
            fontFamily,
            fontWeight,
            letterSpacing,
            ...(props.italic ? { fontStyle: "italic" } : {}),
            ...(props.underline ? { textDecoration: "underline" } : {}),
            color: "#000",
            "& span": {
                fontFamily,
                fontWeight,
                letterSpacing,
                ...(props.italic ? { fontStyle: "italic" } : {}),
                ...(props.underline ? { textDecoration: "underline" } : {}),
            },
            "& p": {
                fontFamily,
                fontWeight,
                letterSpacing,
                ...(props.italic ? { fontStyle: "italic" } : {}),
                ...(props.underline ? { textDecoration: "underline" } : {}),
                marginBottom: 0,
            },
            ...props.sx,
        };
    }, [props.size]);

    return (
        <Typography
            variant={size}
            align={props.align ?? CONTENT_ALIGNMENT_DEFAULT}
            sx={mySx}
            className={props.className}
        >
            {typeof props.label === "object" ? props.label : <span dangerouslySetInnerHTML={{ __html: props.label }} />}
        </Typography>
    );
};

export default Heading;
